export const headerTitle = 'Elevate your creativity with the right plan';

export const isCorrectBillingPeriod = (
  value: string
): value is 'monthly' | 'yearly' => ['monthly', 'yearly'].includes(value);

/**
 * Public domain string hashing function from https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
 *
 * biome-ignore-start lint/suspicious/noBitwiseOperators: Correct usage of bitwise operators to generate a hash
 * biome-ignore-start lint/style/noMagicNumbers: This function needs a ton of magic numbers to work
 */
export const getHash = (str: string): string => {
  const seed = 375; // A fixed seed for consistent hashing
  const hashStringRadix = 16; // Use hexadecimal representation for the hash
  const hashStringPaddingLength = 8; // Length of the hash string

  let h1 = 0xde_ad_be_ef ^ seed,
    h2 = 0x41_c6_ce_57 ^ seed;

  for (let i = 0, character: number; i < str.length; i += 1) {
    character = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ character, 2_654_435_761);
    h2 = Math.imul(h2 ^ character, 1_597_334_677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2_246_822_507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3_266_489_909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2_246_822_507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3_266_489_909);
  return (
    4_294_967_296 * (2_097_151 & h2) +
    (h1 >>> 0).toString(hashStringRadix).padStart(hashStringPaddingLength, '0')
  );
};
/**
 * biome-ignore-end lint/suspicious/noBitwiseOperators: Correct usage of bitwise operators to generate a hash
 * biome-ignore-end lint/style/noMagicNumbers: This function needs a ton of magic numbers to work
 */
